// Дела о претензиях: подписи, светофор, фильтры — без Vue, чтобы проверять тестами. [Claude, 03.11.2026]
export const LIGHTS = [
  { key: 'red', title: 'Критично' },
  { key: 'yellow', title: 'Внимание' },
  { key: 'grey', title: 'Нет срока' },
  { key: 'green', title: 'В норме' },
]

export const KIND_ICONS = {
  our_claim: '📤',
  customer_claim: '📥',
  penalty_risk: '⚠️',
  carrier_recharge: '🔁',
  quality_report: '📊',
}

export function dueText(daysLeft, due) {
  if (daysLeft === null || daysLeft === undefined) return 'без срока'
  const d = due ? due.split('-').reverse().join('.') : ''
  if (daysLeft < 0) return `просрочено на ${-daysLeft} ${plural(-daysLeft)} (${d})`
  if (daysLeft === 0) return `последний день (${d})`
  return `до ${d} · ${daysLeft} ${plural(daysLeft)}`
}

export function plural(n) {
  const a = Math.abs(n) % 100
  const b = a % 10
  if (a > 10 && a < 20) return 'дней'
  if (b === 1) return 'день'
  if (b >= 2 && b <= 4) return 'дня'
  return 'дней'
}

export function filterCases(items, { light = '', query = '', stage = '', stuck = false } = {}) {
  const q = String(query || '').trim().toLowerCase()
  return (items || []).filter((c) => {
    if (light && c.light !== light) return false
    if (stage && c.stage !== stage) return false
    if (stuck && !c.stuck) return false
    if (!q) return true
    return [c.trip_number, c.title, c.client, c.counterparty, c.kind_title, c.status_title]
      .some((v) => String(v || '').toLowerCase().includes(q))
  })
}

export function validateClaim(form) {
  const amount = form.amount === '' || form.amount === null || form.amount === undefined ? null : Number(form.amount)
  if (amount !== null && (Number.isNaN(amount) || amount < 0)) return { ok: false, error: 'Сумма — число без минуса' }
  if (!String(form.tripNumber || '').trim() && !String(form.basis || '').trim()) {
    return { ok: false, error: 'Укажите номер рейса или суть претензии' }
  }
  if (!form.receivedAt) return { ok: false, error: 'Укажите, когда претензия получена — от этой даты идёт срок ответа' }
  return {
    ok: true,
    payload: {
      kind: form.kind || 'customer_claim',
      trip_number: String(form.tripNumber || '').trim() || null,
      amount,
      received_at: `${form.receivedAt}T12:00:00+04:00`,
      basis: String(form.basis || '').trim() || null,
      counterparty: String(form.counterparty || '').trim() || null,
    },
  }
}
